import { module } from 'modujs';
import { isDebug } from '../utils/environment';
import {
    createElementFromHTML,
    templateReplaceMap
} from '../utils/html'

const FETCH_JOB_OFFERS_API_URL = '/api/v1/job-offers';
const CLASS = {
    IS_LOADING: 'is-loading',
    IS_HIDDEN:  'is-hidden',
}

/**
 * Job Offers
 */
export default class extends module {
    init() {
        this.isBusy = false;

        try {
            this.el.classList.add(CLASS.IS_LOADING);

            this.setupContainer();
            this.setupTemplate();
            this.fetchOffers();
        } catch (err) {
            console.error('[App.JobOffers]', 'Something went wrong!', err);
            this.el.classList.remove(CLASS.IS_LOADING);
        }
    }

    setupContainer() {
        const containerElement = this.$('container')[0];
        if (!containerElement) {
            throw new Error('Missing container element');
        }

        this.containerElement = containerElement;
    }

    setupTemplate() {
        const templateItemElement = this.$('template-item')[0];
        if (!templateItemElement) {
            throw new Error('Missing template element');
        }

        const templateItemHTML = templateItemElement.innerHTML.trim();
        if (!templateItemHTML) {
            throw new Error('Missing template HTML');
        }

        this.templateItemHTML = templateItemHTML;
        templateItemElement.remove();
    }

    fetchOffers() {
        if (this.isBusy) {
            console.warn('[App.JobOffers.fetchOffers]','Busy…');
            return;
        }

        this.isBusy = true;
        this.el.classList.add(CLASS.IS_LOADING);

        const requestURL = `${FETCH_JOB_OFFERS_API_URL}?lang=${document.documentElement.lang}`;

        fetch(requestURL)
        .then((response) => {
            isDebug && console.log('[App.JobOffers.fetchOffers]', 'Response Status:', response.status);

            if (response.status === 200) {
                return response.json();
            }

            throw response;
        })
        .then((offers) => {
            isDebug && console.log('[App.JobOffers.fetchOffers]', 'Response Body:', offers);

            if (Array.isArray(offers) && offers.length > 0) {
                offers.forEach((offer) => {
                    const itemHTML = templateReplaceMap(this.templateItemHTML, offer);
                    if (!itemHTML) {
                        isDebug && console.warn('[App.JobOffers.fetchOffers]', `Could not render Job Offer #${offer}`);
                    }

                    const itemElement = createElementFromHTML(itemHTML);
                    if (itemElement) {
                        this.containerElement.appendChild(itemElement);
                    } else {
                        isDebug && console.warn('[App.JobOffers.fetchOffers]', `Could not insert Job Offer #${offer}`);
                    }
                });
            } else {
                throw new Error('No offers available');
            }
        })
        .catch((err) => {
            console.error('[App.JobOffers.fetchOffers]', err);
        })
        .finally(() => {
            this.isBusy = false;
            this.el.classList.remove(CLASS.IS_LOADING);

            let toggleHasOffersElements, toggleHasNoOffersElements;

            if (this.containerElement.childElementCount > 0) {
                toggleHasOffersElements   = 'remove';
                toggleHasNoOffersElements = 'add';
            } else {
                toggleHasOffersElements   = 'add';
                toggleHasNoOffersElements = 'remove';
            }

            document.querySelectorAll('[data-has-job-offers]').forEach((elem) => {
                elem.classList[toggleHasOffersElements](CLASS.IS_HIDDEN);
            });
            document.querySelectorAll('[data-has-no-job-offers]').forEach((elem) => {
                elem.classList[toggleHasNoOffersElements](CLASS.IS_HIDDEN);
            });
        });
    }
}
